import { useElementSize, useSingleton } from '@bydesign-ui/hooks';
import { Table } from '../../../models/table';
export function useCreateTable(ref, options) {
  var table = useSingleton(function () {
    return new Table(options.rowKey);
  });
  useElementSize(ref, function () {
    return true;
  }, function (size) {
    return table.updateTableSize(size);
  });
  table.updateTableOptions(options);
  return table;
}